import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    claimButton: {
      intercomMessage: 'Hello, I would like to report an accident\n',
    },
    content: {
      business: 'Any screen repair, with no limit and no deductible',
      exclude: {
        items: [
          'Any repair paid with a card other than a Shine-issued Business World Debit card;',
          'Any claim made without a professional invoice indicating the phone model and IMEI code;',
          'Phones that do not correspond to those used to connect to Shine.fr.',
        ],
        title: 'This coverage does not include',
      },
      include: {
        items: [
          '{0}, limited to one repair per year per person, for the entire company;',
          'The repair of devices linked only to the Shine account;',
          'Repairs paid with a Shine card, in any specialized phone repair shop in France.',
        ],
        title: 'This coverage includes',
      },
      plus: 'Up to €200 reimbursed for a screen repair, with a €50 deductible',
      pro: 'Up to €200 reimbursed for a screen repair, no deductible',
    },
    similarOffersTitle: 'Other related insurances',
    title: 'Phone Screen Damage Insurance',
  },
  fr: {
    claimButton: {
      intercomMessage: 'Bonjour, je souhaiterais déclarer un accident\n',
    },
    content: {
      business: 'Toute réparation d’écran, sans plafond et sans franchise',
      exclude: {
        items: [
          'Toute réparation payée avec une carte autre qu’une carte Business World Debit émise par Shine ;',
          'Toute demande effectuée sans facture professionnelle indiquant le modèle de téléphone et le code IMEI ;',
          'Les téléphones qui ne correspondent pas à ceux utilisés pour se connecter à Shine.fr.',
        ],
        title: 'Cette garantie n’inclut pas',
      },
      include: {
        items: [
          "{0}, dans la limite d'une réparation par an et par personne, pour toute l’entreprise ;",
          'La réparation des appareils liés au compte Shine uniquement ;',
          'Les réparations payées avec une carte Shine, dans tout magasin spécialisé en réparation de téléphone, en France.',
        ],
        title: 'Cette garantie inclut',
      },
      plus: 'Jusqu’à 200 € remboursés pour une réparation d’écran, avec 50 € franchise,',
      pro: 'Jusqu’à 200 € remboursés pour une réparation d’écran, sans franchise',
    },
    similarOffersTitle: 'Autres assurances liées',
    title: 'Casse écran téléphone',
  },
} as const);

export default locales;
